module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_vm._m(0)]), _vm._v(" "), _c('button', {
    class: 'btn btn-default ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v("機器・組込情報の申請が完了しました。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-472b8f68","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/device-embedded-information-application-confirmation-modal.vue
// module id = 977
// module chunks = 0